import { TFunction } from "i18next";

export const isValidateYear = (value: number, t: TFunction<"validations">) => {
  const currentYear = new Date().getFullYear();
  if (value < 1980 || value > currentYear) {
    return t("wrongYear");
  }
  return null;
};

export const validationsKettle = (t: TFunction<"validations">) => {
  return {
    kettleBrand: (value: string | null) => !value && t("required"),
    kettleYear: (value: number | "") => (!value ? t("required") : isValidateYear(value, t)),
  };
};
